export function createEnumValidator<T extends Record<string, string>>(e: T) {
  const enumValues = Object.values(e);
  return (value: string): value is T[keyof T] => enumValues.includes(value);
}
